/**
 * 图片灯箱组件
 * 用于大图查看
 */

import React from 'react';
import { X } from 'lucide-react';

interface LightboxProps {
  /** 当前显示的图片 URL */
  src: string | null;
  /** 图片标题 */
  title: string;
  /** 关闭回调 */
  onClose: () => void;
  /** v1.4.57 遮罩层级类（默认 z-50；高层级面板内复用传更高 z，如脚本资产编辑面板 z-[310]） */
  className?: string;
}

/**
 * 图片灯箱组件
 * 全屏显示单张图片，支持点击关闭
 */
export const Lightbox: React.FC<LightboxProps> = ({ src, title, onClose, className }) => {
  if (!src) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-black/80 p-4 [container-type:size] ${className ?? 'z-50'}`}
      onClick={onClose}
    >
      <div
        className="relative max-w-[90%] max-h-[90%]"
        onClick={e => e.stopPropagation()}
      >
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 w-8 h-8 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center text-white shadow-lg transition-colors"
        >
          <X size={16} />
        </button>

        {/* 图片 */}
        <img
          src={src}
          alt={title}
          className="max-w-full max-h-[85cqh] rounded-lg shadow-2xl object-contain"
        />

        {/* 标题 */}
        {title && (
          <div className="absolute bottom-0 left-0 right-0 px-3 py-2 bg-gradient-to-t from-black/80 to-transparent rounded-b-lg">
            <p className="text-[12px] text-white/90 truncate">{title}</p>
          </div>
        )}
      </div>
    </div>
  );
};
